function str(v) {
    return v != null ? String(v).trim() : '';
}
function shortId(id) {
    if (!id)
        return '';
    if (id.length <= 12)
        return id;
    return `${id.slice(0, 8)}…`;
}
/**
 * Raw REFERENCE column: keep `reference_type - id` as stored.
 * Human meaning belongs in Activity.
 */
export function usdLedgerReferenceLabel(row) {
    var _a, _b;
    const refType = str((_a = row.referenceType) !== null && _a !== void 0 ? _a : row.reference_type);
    const refId = str((_b = row.referenceId) !== null && _b !== void 0 ? _b : row.reference_id);
    if (!refType && !refId) {
        return { primary: '—', title: '—' };
    }
    const idBit = shortId(refId);
    const full = [refType, refId].filter(Boolean).join(' - ');
    const primary = refType && idBit ? `${refType} - ${idBit}` : refType || idBit;
    return {
        primary,
        title: full,
    };
}
/** Single-line label for CSV / plain export. */
export function usdLedgerReferencePlain(row) {
    var _a, _b;
    const refType = str((_a = row.referenceType) !== null && _a !== void 0 ? _a : row.reference_type);
    const refId = str((_b = row.referenceId) !== null && _b !== void 0 ? _b : row.reference_id);
    if (!refType && !refId)
        return '—';
    return [refType, refId].filter(Boolean).join(' - ');
}
